export default __webpack_public_path__ + "img/b8b1c563341195ee1f6af633af3ea80c.jpg";